exports.components = {
  "component---node-modules-commercetools-docs-gatsby-theme-docs-src-templates-page-content-js": () => import("./../../../../../node_modules/@commercetools-docs/gatsby-theme-docs/src/templates/page-content.js" /* webpackChunkName: "component---node-modules-commercetools-docs-gatsby-theme-docs-src-templates-page-content-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

